export default "__VITE_ASSET__f7bc2fe3__"